"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Table_1 = __importDefault(require("@modules/Table"));
const TableBody_1 = __importDefault(require("@modules/TableBody"));
const TableCell_1 = __importDefault(require("@modules/TableCell"));
const TableHead_1 = __importDefault(require("@modules/TableHead"));
const TableRow_1 = __importDefault(require("@modules/TableRow"));
const arrayUtils_1 = require("@utils/arrayUtils");
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const SearchResultTable = (props) => {
    var _a;
    const { searchResultTableTitles } = props;
    const { searchResult: data } = (0, react_redux_1.useSelector)((state) => (Object.assign({}, state.df0001)));
    const [tableData, setTableData] = react_1.default.useState({
        tableTitle: searchResultTableTitles,
        tableBody: data
    });
    const table = react_1.default.useRef();
    const tableElement = table.current;
    const [tableHeight, setTableHeight] = react_1.default.useState(0);
    /**
     * 回傳目前參數的欄位是否顯示
     * @param titleCode 欄位代碼 titleCode
     * @returns
     */
    const checkIsColumnDisplay = (titleCode) => {
        let isColumnDisplay = false;
        tableData.tableTitle.forEach((item) => {
            if (item.titleCode === titleCode && item.isDisplay)
                isColumnDisplay = true;
        });
        return isColumnDisplay;
    };
    const isResizeShow = (index) => {
        const tableTitleLength = tableData.tableTitle.length;
        const FunctionalButtonColumnIndex = tableData === null || tableData === void 0 ? void 0 : tableData.tableTitle.findIndex((item) => item.titleCode === 'functionalButtons');
        let isSkipColumn = index !== tableTitleLength - 1;
        if (FunctionalButtonColumnIndex >= 0)
            isSkipColumn = isSkipColumn && index !== FunctionalButtonColumnIndex;
        return isSkipColumn && !(0, arrayUtils_1.isEmptyArray)(tableData.tableBody);
    };
    react_1.default.useEffect(() => {
        var _a;
        const newTableHeight = (_a = tableElement === null || tableElement === void 0 ? void 0 : tableElement.offsetHeight) !== null && _a !== void 0 ? _a : 0;
        setTableHeight(newTableHeight);
    }, [tableData]);
    react_1.default.useEffect(() => {
        return setTableData(Object.assign(Object.assign({}, tableData), { tableBody: data }));
    }, [data]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "securitiesSelectData__searchResultTable_wrapper", ref: table }, { children: (0, jsx_runtime_1.jsxs)(Table_1.default, Object.assign({ className: "table__column_sticky" }, { children: [(0, jsx_runtime_1.jsx)(TableHead_1.default, { children: (0, jsx_runtime_1.jsx)(TableRow_1.default, { children: tableData.tableTitle.map((title, index) => {
                            if (title.isDisplay) {
                                return ((0, jsx_runtime_1.jsx)(TableCell_1.default, Object.assign({ isResizeHandleShow: isResizeShow(index), id: title.titleCode, tableHeight: tableHeight }, { children: title.titleText }), index));
                            }
                            return (0, jsx_runtime_1.jsx)(react_1.default.Fragment, {}, index);
                        }) }) }), (0, jsx_runtime_1.jsx)(TableBody_1.default, Object.assign({ noDataText: "\u67E5\u8A62\u7D50\u679C\u7121\u8CC7\u6599" }, { children: (_a = tableData.tableBody) === null || _a === void 0 ? void 0 : _a.map((item, index) => ((0, jsx_runtime_1.jsx)(TableRow_1.default, { children: Object.entries(item).map((subItem, index) => {
                            const [titleCode, cellValue] = subItem;
                            if (checkIsColumnDisplay(titleCode))
                                return ((0, jsx_runtime_1.jsx)(TableCell_1.default, Object.assign({ id: titleCode }, { children: cellValue }), index));
                            return (0, jsx_runtime_1.jsx)(react_1.default.Fragment, {}, index);
                        }) }, index))) }))] })) })));
};
exports.default = SearchResultTable;
